<tcc-mono-dialog-layout
  [title]="'Selecteer een klant'"
  [displayBottomButtons]="false"
  [displaySearch]="true"
  (onSearch)="setQ($event)"
>
  <ion-content>
    <tcc-mono-stacked-list
      [items]="customers$ | async"
      [fields]="fields"
      (itemClicked)="selectCustomer($event)"
      (loadData)="loadData($event)"
    ></tcc-mono-stacked-list>
  </ion-content>
</tcc-mono-dialog-layout>
